<template>
    <div class="queryBox" style="margin-top:10px;">
        <!-- #页面操作按钮-->
        <!-- <Affix :offset-top="90">
            <Card class="affix-card-head">
                <div slot="title">
                    <div>
                        <Button type="primary" icon="md-close">关闭</Button>
                        <Button class="ivu-ml-8" icon="ios-copy" type="primary" v-ab-btn-rights:supplier_select_btn
                            @click="search()">
                            临时保存
                        </Button>
                    </div>
                    <div>
                        <Button to="/hrm/Certificateofapproval" type="primary" icon="md-arrow-up"
                            style="margin-left: 10px">申请</Button>
                    </div>
                </div>
            </Card>
        </Affix> -->
        <card :padding="5">
            <Form ref="searchForm" class="searchForm" :label-width="110" label-position="right">
                <div class="searchForm-div">
                    <!-- 证书申请 -->
                    <h1 v-if="applyType==1">{{$t('komatsu.caCert.carTitleApply')}}</h1>
                    <!-- 证书更新 -->
                    <h1 v-if="applyType==2">{{$t('komatsu.caCert.carTitleUpdate')}}</h1>
                    <!-- 证书废除 -->
                    <h1 v-if="applyType==3">{{$t('komatsu.caCert.carTitleAbolish')}}</h1>
                </div>
                <div class="ivu-card-head">
                    <ul slot="title">
                        <!-- 单据编号 -->
                        <li v-if="isReadonly">[{{$t('komatsu.caCert.applySerial')}}：<span>{{data.certApplyBus.applySerial}}</span>]</li>
                        <!-- 申请人姓名 -->
                        <li>{{$t('komatsu.caCert.applyUser')}}：<span>{{data.certApplyBus.applyUser}}</span></li>
                        <!-- 公司邮箱 -->
                        <li>{{$t('komatsu.caCert.applyUserEmail')}}：<span>{{data.certApplyBus.applyUserEmail}}</span></li>
                        <!-- 公司全称 -->
                        <li>{{$t('komatsu.caCert.companyFullName')}}：<span>{{data.certApplyBus.companyFullName}}</span></li>
                    </ul>
                </div>

                <Row :gutter="24" type="flex" justify="center" align="middle" class="row">
                    <Col span="24" offset="0" class="row-col">
                    <table class="i-iview-table form-table from-ta" border="0">
                        <tbody>
                            <tr>
                                <!-- 系统分类 -->
                                <td style="width:15%">{{$t('komatsu.caCert.systemCategory')}}</td>
                                <td>
                                    <div v-if="isReadonly || applyType==3 || applyType==2">
                                        {{systemCategoryList[data.certApplyBus.systemCategory]}}
                                        <span v-if="data.certApplyBus.systemCategory=='KOPEN' && data.certApplyBus.systemCategorySecondary">
                                            - {{data.certApplyBus.systemCategorySecondary}}
                                        </span>
                                    </div>
                                    <div v-else >
                                        <Select 
                                            :style="{width:data.certApplyBus.systemCategory=='KOPEN'?'77%':'100%'}"
                                            v-model="data.certApplyBus.systemCategory" 
                                            :desc="$t('komatsu.caCert.systemCategory')" 
                                            v-ab-validate="{'required':true}"
                                            :disabled="isReadonly"
                                            @on-change="systemCategoryChange"
                                        >
                                            <Option v-for="(name,key) in systemCategoryList" :value="key" :key="key">
                                                {{ name }}
                                            </Option>
                                        </Select>
                                        <!-- kopen 二级分类 -->
                                        <Select v-if="data.certApplyBus.systemCategory=='KOPEN'" 
                                            style="width:23%"
                                            v-model="data.certApplyBus.systemCategorySecondary" 
                                            :disabled="isReadonly"
                                            v-ab-validate="{'required':true}"
                                            :desc="$t('komatsu.caCert.systemCategory')"
                                        >
                                            <Option v-for="(name,key) in kopenTypeList" :value="key" :key="key">
                                                {{ name }}
                                            </Option>
                                        </Select>
                                    </div>
                                </td>
                                <td style="width:15%">
                                    <!-- 供应商/公司 -->
                                    {{$t('komatsu.caCert.companyShortName')}}
                                </td>
                                <td>
                                    <!-- {{data.certApplyBus.companyShortName}} -->
                                    <div v-if="isReadonly || applyType==3 || applyType==2 || supplierCompanyList.length<=0">
                                        {{data.certApplyBus.companyShortName}}
                                    </div>
                                    <Select v-else :label-in-value="true" @on-change="companyShortChange" :key="companyShortSelectKey" v-model="data.certApplyBus.companyShortId" >
                                        <Option v-for="(item,index) in supplierCompanyList" :value="item.id" :key="index">{{ item.name }}</Option>
                                    </Select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </Col>
                </Row>

                <div class="searchForm-div-d" style="padding-top:10px;" >
                    <span v-if="!isReadonly && applyType==1">
                        <!-- 选择用户 -->
                        <ab-cust-dialog v-if="supplierCompanyList.length>0" :expand="false" :defaultData="defaultSelectUserData" dialogKey="yhcx（zzfl）" :display="true" slot="append"
                            v-on:ok="pushOrgRelationList($event)" :param="selectUserParams">
                            <!-- <Icon style="margin-top: 4px;" size="14" type="ios-search" /> -->
                            <Icon class="searchForm-div-icon" size="14" type="ios-people" />
                            <span>{{$t('komatsu.caCert.btn.selectUser')}}</span>
                        </ab-cust-dialog>
                    </span>

                    <!-- 提示 -->
                    <span  v-if="!isReadonly && applyType==1 || applyType==2 " style="padding-left:10px;color:red;">
                        <!-- 【每个用户系统证书最多只能申请2张证书。】 -->
                        {{$t('komatsu.caCert.message.maxCertNumberText')}}
                    </span>
                </div>

                <Row :gutter="24" type="flex" justify="center" align="middle" class="Row">
                    <Col span="24" offset="0">

                        <table class="form-table">
                            <thead>
                                <tr class="firstRow">
                                    <td width="3%" v-if="!isReadonly && supplierCompanyList.length>0">
                                        {{ $t('page.common.del') }}
                                    </td>
                                    <td width="10%">
                                        <!-- 使用人 -->
                                        {{$t('komatsu.caUserCert.useUserName')}}
                                    </td>
                                    <td width="10%">
                                        <!-- 公司邮箱 -->
                                        {{$t('komatsu.caCert.applyUserEmail')}}
                                    </td>
                                    <td width="10%">
                                         <!-- 证书有效期 -->
                                        {{$t('komatsu.caCert.effective')}}
                                    </td>
                                    <td width="10%">
                                        <!-- 证书数量 -->
                                        {{$t('komatsu.caCert.certNumber')}}
                                    </td>
                                    
                                    <td width="10%" v-if="data.certApplyBus.systemCategory=='KWING'">
                                        <!-- KING CODE -->
                                        {{$t('komatsu.caCert.receiptNumber')}}<span v-if="data.certApplyBus.systemCategory=='KWING'"></span>
                                    </td>
                                    <td width="10%" v-if="data.certApplyBus.systemCategory=='KWING'">
                                        <!-- KING ID -->
                                        {{$t('komatsu.caCert.kwingId')}}<span v-if="data.certApplyBus.systemCategory=='KWING'"></span>
                                    </td>

                                    <td width="10%">
                                        <!-- 备注 -->
                                        {{$t('page.common.remark')}}
                                    </td>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr  v-for="(item,index) in data.certApplyBus.caCertInfoList" :key="index">
                                    <td v-if="!isReadonly && supplierCompanyList.length>0" width="2%">
                                        <Button type="error" icon="md-close" @click="handleDelete(index)"></Button>
                                    </td>
                                    <td style="text-align:left;">
                                        <div v-if="isReadonly">
                                            {{item.useUserName}}
                                        </div>
                                        <Input v-else clearable v-model="item.useUserName" :disabled="true"></Input>
                                    </td>
                                    <td style="text-align:left;">
                                        <div v-if="isReadonly">
                                            {{item.useUserEmail}}
                                        </div>
                                        <Input v-else clearable v-model="item.useUserEmail" :disabled="true"></Input>
                                    </td>
                                    <td>
                                        <div v-if="isReadonly">
                                            {{effectiveList[item.effective]}}
                                        </div>
                                        <Select v-else v-model="item.effective" 
                                            :disabled="isReadonly  || applyType==3 || (!isItManage && !isAdmin)"
                                        >
                                            <Option v-for="(name,key) in effectiveList" :value="key" :key="key">
                                                {{ name }}
                                            </Option>
                                        </Select>
                                    </td>
                                    <td>
                                        <div v-if="isReadonly">
                                            {{(item.certCount?item.certCount:0)}}/2
                                        </div>
                                        <Input class="input-center" v-else :value="(item.certCount?item.certCount:0) + '/2'" :disabled="true"></Input>
                                    </td>
                                    
                                    <td v-if="data.certApplyBus.systemCategory=='KWING'" style="text-align:left;">
                                        <div v-if="isReadonly">
                                            {{item.receiptNumber}}
                                        </div>
                                        <Input v-else clearable v-model="item.receiptNumber" :disabled="isReadonly  || applyType==3"></Input>
                                    </td>
                                    <td v-if="data.certApplyBus.systemCategory=='KWING'" style="text-align:left;">
                                        <div v-if="isReadonly">
                                            {{item.kwingId}}
                                        </div>
                                        <Input v-else clearable v-model="item.kwingId" :disabled="isReadonly  || applyType==3"></Input>
                                    </td>

                                    <td style="text-align:left;">
                                        <div v-if="isReadonly">
                                            {{item.remark}}
                                        </div>
                                        <Input v-else clearable v-model="item.remark" :disabled="isReadonly"></Input>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </Col>
                </Row>

                <Row style="margin-top:20px;">

                    <Col :xs="24" :sm="24" :md="12" :lg="24" class="col">
                        <!-- 申请理由 -->
                        <!-- 请在申请第二张证书的时候务必填写理由。 -->
                        <FormItem :label-width="100" :label="$t('komatsu.caCert.reason')">
                            <div v-if="isReadonly" class="ivu-input-wrapper" style="border:1px solid #e8eaec;border-radius:3px;min-height:80px;">
                                {{data.certApplyBus.reason}}
                            </div>
                            <div v-else>
                                <Input type="textarea" v-model="data.certApplyBus.reason"  
                                    :placeholder="isReadonly?'':$t('komatsu.caCert.reasonPlaceholder')"
                                    :desc="$t('komatsu.caCert.reason')" 
                                    v-ab-validate="{'maxlength':500,}"
                                    :readonly="isReadonly"
                                ></Input>
                            </div>
                           
                        </FormItem>

                        <!-- 添加附件 -->
                        <FormItem :label-width="100" :label="isReadonly?$t('page.common.file'):$t('komatsu.caCert.attachment')">

                            <ab-upload
                                upType='drag'
                                :isCustomUpIcon="true"
                                v-model="data.certApplyBus.attachment" 
                                v-bind:ab-permission="permission.certApplyBus.caCert.attachment" 
                            >​
                                <div slot="upload-icon" style="padding:5px 0;">
                                    <Icon type="ios-cloud-upload" size="42" style="color: #3399ff"></Icon>
                                </div>
                            </ab-upload>

                        </FormItem>
                    </Col>
                    
                </Row>

            </Form>
        </card>
    </div>
</template>

<script>
    import log from "../../menu/modules/log";

    export default {
        name: "certificateapplication",
        data() {
            return {
                selectUserParams: {
                    leftTreeDialogParam:{
                      path_: '',  
                    },
                    group_id_: ''
                },

                isReadonly: false,//是否只读
                applyType: 1, //申请类型 新规=1，更新=2，废除=3
                serialNumber:'',//单据编号-流水号 001
                
                data:this.$parent.data,
                permission:this.$parent.permission,
                tablePermission:this.$parent.tablePermission,
                userInfo:this.getUserInfo(),//用户信息
                systemCategoryList:{},//系统分类下拉列表数据
                sysStaffCategoryList:{},//系统担当-所担当的系统
                effectiveList:{},//有效期下拉列表数据
                curDate: new Date().format("yyyy-MM-dd"),//当前日期
                defEffective:'12',//默认有效期 12一个月

                isItManage:false,//是否IT管理员
                isAdmin:false,//是否admin管理员
                supplierCompanyList:[],//供应商/公司列表
                companyShortSelectKey:0,//供应商/公司列表 select key 用于重新渲染组件
                defaultSelectUserData:[],//弹出选择用户默认显示自己  

                kopenTypeList:{},//KOPEN 分类的二级分类
            };
        },
         created(){
            console.log("=======this======",this);

            if(this.data.certApplyBus.applyType){
                this.applyType = this.data.certApplyBus.applyType;
            }else{
                //获取流程申请类型 
                let routerParams = this.$route.params;
                let flowKey = routerParams.flowKey;
                //新规=1，更新=2，废除=3
                if(flowKey=="certApply"){
                    this.applyType = 1;
                }else if(flowKey=="certUpdate"){
                    this.applyType = 2;
                }else if(flowKey=="certAbolish"){
                    this.applyType = 3;
                }
            }

            //是否IT管理员
            this.isItManageRole();
            //是否admin
            this.getIsAdmin();
            //系统担当-所担当的系统
            this.getSysStaffCategoryList();

            this.isReadonly = this.tablePermission.certApplyBus.caCert == 'r';

            if(!this.data.certApplyBus.id){
                this.initBusData();
            }else{
                if(!this.isReadonly){
                    //申请人信息
                    this.getUserDetail(this.userInfo.id,data=>{
                        this.$set(this.data.certApplyBus, 'applyUserAccount', data.account);
                        this.$set(this.data.certApplyBus, 'applyUserEmail', data.email);
                        this.defaultSelectUserData.push(data);
                    });
                }
            }

            //初始化基本数据-数据字典
            this.initBaseData();

            //初始化案件名-流水号
            if(!this.isReadonly){
                this.getTaskNameNo();
            }

            //获取用户证书数量
            this.getCertCount();

            //获取供应商/公司下拉列表
            this.getSupplierCompany();

            //选择用户过滤数据参数
            this.selectUserParams.leftTreeDialogParam.path_ = this.data.certApplyBus.companyShortId;
            this.selectUserParams.group_id_ = this.data.certApplyBus.companyShortId;
            this.selectUserParams.groupId = this.data.certApplyBus.companyShortId;

        },
        mounted: function () {
           
        },
        methods: {
            //初始化数业务据
            initBusData(){
                console.log("=======userInfo======",this.userInfo);

                //申请类型
                this.$set(this.data.certApplyBus, 'applyType', this.applyType);
                //状态 //草稿=1，审批中=2，审批完了=3
                this.$set(this.data.certApplyBus, 'status', '1');

                //证书更新数据初始化
                this.initCertUpdateData();

                let userId = this.userInfo.id;
                let userName = this.userInfo.name;

                let defaultCaCertInfo = {
                    useUserId:userId,
                    useUserName:userName,
                    useUserEmail:'',
                    companyId:'',
                    companyShortName:'',
                    companyName:'',
                    receiptNumber:'',
                    startDate: this.curDate,
                    effective: this.defEffective,
                    createdBy: userId,
                    createdTime: this.curDate,
                    updateBy: userId,
                    updateTime: this.curDate,
                };

                //申请人信息
                this.getUserDetail(userId,data=>{
                    this.$set(this.data.certApplyBus, 'applyUserAccount', data.account);
                    this.$set(this.data.certApplyBus, 'applyUserEmail', data.email);
                    defaultCaCertInfo.useUserAccount = data.account;
                    defaultCaCertInfo.useUserEmail = data.email;
                    this.defaultSelectUserData.push(data);
                });
                this.$set(this.data.certApplyBus, 'applyUserId', userId);
                this.$set(this.data.certApplyBus, 'applyUser', userName);
                

                //当前用户部门
                let currentOrg = this.userInfo.currentOrg;
                if(currentOrg){
                    let groupId  = currentOrg.groupId;
                    this.$set(this.data.certApplyBus, 'applyDepId', groupId);
                    this.$set(this.data.certApplyBus, 'applyDep', currentOrg.groupName);
                    //获取供应商/公司
                    this.getCompany('',groupId,data=>{
                        let companyEnShortName = data.enShortName?data.enShortName:'';
                        this.$set(this.data.certApplyBus, 'companyId', data.id);
                        this.$set(this.data.certApplyBus, 'companyFullName', data.name);

                        if(this.applyType==1){
                            this.$set(this.data.certApplyBus, 'companyShortName', data.name);
                            this.$set(this.data.certApplyBus, 'companyShortId', data.id);
                        }

                        defaultCaCertInfo.companyId = data.id;
                        defaultCaCertInfo.companyShortName = companyEnShortName;
                        defaultCaCertInfo.companyName = data.name;

                        this.selectUserParams.leftTreeDialogParam.path_ = this.data.certApplyBus.companyShortId;
                        this.selectUserParams.group_id_ = this.data.certApplyBus.companyShortId;
                        this.selectUserParams.groupId = this.data.certApplyBus.companyShortId;

                        //证书编号
                        /* this.getSerialNo('certNumber',number=>{
                            defaultCaCertInfo.receiptNumber = companyEnShortName + number;
                        }); */
                    });
                }

                if(this.applyType==1){
                    let caCertInfoList = this.data.certApplyBus.caCertInfoList;
                    if(!caCertInfoList || caCertInfoList.length<=0){
                        this.data.certApplyBus.caCertInfoList.push(defaultCaCertInfo);
                    }
                }

            },
            //证书更新数据初始化
            initCertUpdateData(){
                
                if(this.applyType!=2 && this.applyType!=3){
                    return;
                }

                let systemCategory = this.$route.query.systemCategory;
                let systemCategoryName = this.$route.query.systemCategoryName;
                let systemCategorySecondary = this.$route.query.systemCategorySecondary;
                let companyId = this.$route.query.companyId;
                this.$set(this.data.certApplyBus, 'companyShortId', companyId);
                this.getCompany('',companyId,data=>{
                    if(data){
                        this.$set(this.data.certApplyBus, 'companyShortName', data.name);
                    }
                });
                
                this.$set(this.data.certApplyBus, 'systemCategory', systemCategory);
                this.$set(this.data.certApplyBus, 'systemCategoryName', systemCategoryName);
                this.$set(this.data.certApplyBus, 'systemCategorySecondary', systemCategorySecondary);

                let caCertInfoIds = this.$route.query.caCertInfoIds;
                if(caCertInfoIds){
                    this.getCaCertInfoByIds(caCertInfoIds,rows=>{
                        rows.forEach((row,i)=>{
                            let startDate = row.startDate;
                            if(this.applyType==2){
                                startDate = row.endDate;
                            }
                            let caCertInfo = {...row,...{id:'',certId:'',startDate:startDate}};
                            this.$set(this.data.certApplyBus.caCertInfoList, i, caCertInfo);
                        });
                        //获取用户证书数量
                        this.getCertCount();
                    });
                }
                
            },
            //初始化基本数据
            initBaseData(){
                //初始化系统分类 下拉数据
                /* this.initDictData('system_category',data=>{
                    data.forEach(row=>{         
                        this.$set(this.systemCategoryList, row.key, row.name);
                    });
                }); */
                //初始化-KOPEN 分类的二级分类
                this.initDictData('kopen_type',data=>{
                    data.forEach(row=>{         
                        this.$set(this.kopenTypeList, row.key, row.name);
                    });
                });
                this.getSystemCategoryList(data=>{
                    data.forEach(row=>{         
                        this.$set(this.systemCategoryList, row.sysType, row.sysTypeName);
                    });
                });

                //初始化证书有效期 下拉数据
                this.initDictData('effective',data=>{
                    data.forEach(row=>{
                        this.$set(this.effectiveList, row.key, row.name);
                    });
                });
            },
            //获取系统分类
            getSystemCategoryList(call){
                let url = "/ca/casyscategorymatch/getApplySysType";
                let post = this.abHttpUtil.postForm(url, {
                    status$VEQ : '1',
                    order:'asc',
                    sort:'id_'
                });
                this.abTools.getResultData(post, (data,result) => {
                   if(data && data.length>0){
                      call(data); 
                   }
                });
            },
            //获取证书申请明细
            getCaCertInfoByIds(ids,call){
                let url = "/ca/causercert/listJson2";
                let post = this.abHttpUtil.postForm(url, {
                    id_$VIN : ids,
                    offset:0,
                    limit:1000
                });
                this.abTools.getResultData(post, (data,result) => {
                    if(result.rows){
                        let d = [];
                        result.rows.forEach(row=>{
                            d.push({
                                useUserId:row.useUserId,
                                useUserAccount:row.useUserAccount,
                                useUserName:row.useUserName,
                                useUserEmail:row.useUserEmail,
                                startDate:row.startDate,
                                endDate:row.endDate,
                                effective:row.effective,
                                receiptNumber:row.receiptNumber,
                                kwingId:row.kwingId,
                                companyId:row.companyId,
                                companyShortName:row.companyShortName,
                                companyName:row.companyName,
                                userCertId:row.id,
                            });
                        });

                        call(d);
                    }
                });
            },
            getCaCertInfoByIds2(ids,call){
                let url = "/ca/cacertinfo/listJson";
                let post = this.abHttpUtil.postForm(url, {
                    id_$VIN : ids,
                    offset:0,
                    limit:1000
                });
                this.abTools.getResultData(post, (data,result) => {
                   call(result.rows);
                });
            },
            //获取当前登录用户信息
            getUserInfo(){
                 return this.$store.state.admin.user.info;
            },
            //是否IT管理员角色
            isItManageRole(){
                this.abTools.existAuthorities(['it_manage'],flag=>{
                    this.isItManage = flag;
                });
            },
            //是否admin
            getIsAdmin(){
                this.abTools.isAdmin(flag=>{
                    this.isAdmin = flag;
                });
            },
            //系统担当-所担当的系统
            getSysStaffCategoryList(){
                let url = "/ca/casyscategorymatch/getBySysStaff";
                let post = this.abHttpUtil.postForm(url, {
                });
                this.abTools.getResultData(post, (data,result) => {
                    if(data && data.length>0){
                        data.forEach(row=>{
                            this.sysStaffCategoryList[row.sysType] = row;
                        });
                    }
                });
            },
            getUserDetail(userId,call){
                let url = "/org/user/get";
                let post = this.abHttpUtil.postForm(url, {
                    id : userId,
                });
                this.abTools.getResultData(post, (data,result) => {
                    if(data){
                        call(data);
                    }
                });
            },
            getTaskNameNo(){
                this.getSerialNo('taskNameNo',number=>{
                    this.data.certApplyBus.taskNameNo = number;
                });
            },
            //获取用户证书数量
            getCertCount(){
                let systemCategory = this.data.certApplyBus.systemCategory;
                let caCertInfoList = this.data.certApplyBus.caCertInfoList;
                if(systemCategory && caCertInfoList && caCertInfoList.length>0){

                    caCertInfoList.forEach((row,i)=>{
                        let url = "/ca/causercert/getCertCount";
                        let post = this.abHttpUtil.postForm(url, {
                            userId : row.useUserId,
                            systemCategory : systemCategory,
                        });
                        this.abTools.getResultData(post, (data,result) => {
                            ////申请类型 新规=1，更新=2，废除=3
                            if(this.applyType==2){
                                data = data-1;
                            }
                            row.certCount = data;
                            
                            this.$forceUpdate();
                        });
                    });

                }

            },
            //公司信息
            getCompany(userId,groupId,call){
                let url = "/orgManage/getCompany";
                let post = this.abHttpUtil.postForm(url, {
                    userId : userId,
                    groupId : groupId
                });
                this.abTools.getResultData(post, (data,result) => {
                    if(data){
                        call(data);
                    }
                });
            },
            //获取字典数据
            initDictData(dictKey,call){
                let url = "/sys/dataDict/getDictData";
                let post = this.abHttpUtil.postForm(url, {
                    dictKey : dictKey
                });
                this.abTools.getResultData(post, data => {
                    if(data && data.length>0){
                        call(data);
                    }
                });
            },
            //获取流水号
            getSerialNo(alias,call){
                let url = "/sys/serialNo/getNextIdByAlias";
                let post = this.abHttpUtil.postForm(url, {
                    alias: alias
                });
                this.abTools.getResultData(post, data => {
                    call(data);
                });
            },
            //表单校验
            async custValid() {
                let msg = '';

                //this.$parent.$validity = this.$validity;

                if(this.isReadonly){
                    return true;
                }

              
               
                let systemCategory = this.data.certApplyBus.systemCategory;
                let systemCategorySecondary = this.data.certApplyBus.systemCategorySecondary;
                let companyShortName = this.data.certApplyBus.companyShortName;
                let companyShortId = this.data.certApplyBus.companyShortId;
                let companyFullName = this.data.certApplyBus.companyFullName;

                if(!systemCategory){
                    msg += $t('page.common.choose') + $t('komatsu.caCert.systemCategory') + ' <br/>';
                }else{
                    if(systemCategory=='KOPEN' && !systemCategorySecondary){
                        msg += $t('page.common.choose') + $t('komatsu.caCert.systemCategory') + ' <br/>';
                    }
                }
                
                if(!companyShortName){
                    msg += $t('komatsu.caCert.companyShortName') + $t('page.common.msg.isNotNull')  + ' <br/>';
                }
                
                if(!companyFullName){
                    msg += $t('komatsu.caCert.companyFullName') + $t('page.common.msg.isNotNull')  + ' <br/>';
                }

                let caCertInfoList = this.data.certApplyBus.caCertInfoList;
                if(!caCertInfoList || caCertInfoList.length<=0){
                    msg += $t('komatsu.caUserCert.applyNumberNotNull')  + ' <br/>';
                }

                  //废除申请
                if(this.applyType==3){

                    for (let i = 0; i < caCertInfoList.length; i++) {
                        const item = caCertInfoList[i];
                        //申请第二张证书时必须填写申请理由
                        if(!this.data.certApplyBus.reason && !item.remark){
                            msg += $t('komatsu.caCert.reasonPlaceholder') + ' <br/>';
                            break;
                        }
                    }

                    if(msg){
                        this.$Message.error('<br/>' + msg);
                        return false;
                    }

                    return true;
                }

                //系统担当代理其他用户申请时-只能申请自己所担当的系统
                if(!this.isAdmin && !this.isItManage && Object.keys(this.sysStaffCategoryList).length>0){
                    let ssc = this.sysStaffCategoryList[systemCategory];
                    if(!ssc){
                        for (let i = 0; i < caCertInfoList.length; i++) {
                            const item = caCertInfoList[i];
                            if(item.useUserId!=this.data.certApplyBus.applyUserId){
                                //您没有为其他用户申请XXX系统的权限
                                msg += $t('komatsu.caUserCert.noAgentAuth',{sysName:this.data.certApplyBus.systemCategoryName})  + ' <br/>';
                                break;
                            }
                        }
                    }
                }

                let companyId = '';
                for (let i = 0; i < caCertInfoList.length; i++) {
                    const item = caCertInfoList[i];

                    /* if(!item.startDate){
                        msg += $t('page.common.choose') + $t('page.common.detailNo',{index:(i+1)}) + $t('komatsu.caCert.startDate') + ' <br/>';
                    } */

                    //使用人必填
                    if(!item.useUserName){
                        msg += $t('page.common.detailNo',{index:(i+1)}) + $t('komatsu.caUserCert.useUserName') + $t('page.common.msg.isNotNull') + ' <br/>';
                    }

                    //用户未设置所属组织
                    if(!item.companyId || !item.companyShortName || !item.companyName){
                        msg += $t('page.common.detailNo',{index:(i+1)})  + $t('komatsu.caUserCert.useUserName') + '['+item.useUserName+']' + $t('page.org.group') + $t('page.common.msg.isNotNull') + ' <br/>';
                    }

                    //证书有效期必填
                    if(!item.effective){
                        msg += $t('page.common.detailNo',{index:(i+1)}) + $t('komatsu.caCert.effective') + $t('page.common.msg.isNotNull') + ' <br/>';
                    }

                    //公司邮箱必填
                    if(!item.useUserEmail){
                        msg += $t('page.common.detailNo',{index:(i+1)}) + $t('komatsu.caCert.applyUserEmail') + $t('page.common.msg.isNotNull') + ' <br/>';
                    }
                    //系统分类为 KWING 必填
                    if(systemCategory=='KWING' && !item.receiptNumber){
                        msg += $t('page.common.pleaseEnter') + $t('page.common.detailNo',{index:(i+1)}) +  $t('komatsu.caCert.receiptNumber') + ' <br/>';
                    }
                    //系统分类为 KWING 必填
                    if(systemCategory=='KWING' && !item.kwingId){
                        msg += $t('page.common.pleaseEnter') + $t('page.common.detailNo',{index:(i+1)}) +  $t('komatsu.caCert.kwingId') + ' <br/>';
                    }

                    //使用人必须是同一个供应商/公司
                    if(companyShortId !=item.companyId){
                        msg += $t('komatsu.caUserCert.useUserNoShuyu',{userName:item.useUserName,group:companyShortName}) + ' <br/>';
                    }
                    companyId =  item.companyId;

                    //一个用户 同一个系统最多只能申请两张证书
                    if(item.certCount>=2){
                        msg += $t('page.common.detailNo',{index:(i+1)}) +  $t('komatsu.caCert.certNumber') + $t('komatsu.caCert.message.maxCertNumber') + ' <br/>';
                    }
                    
                }

                for (let i = 0; i < caCertInfoList.length; i++) {
                    const item = caCertInfoList[i];
                    //申请第二张证书时必须填写申请理由
                    if(item.certCount>=1 && !this.data.certApplyBus.reason && !item.remark){
                        msg += $t('komatsu.caCert.reasonPlaceholder') + ' <br/>';
                        break;
                    }
                }

                //校验审批中的用户证书数量
                if(!msg){
                    let approvelCertCount = await this.getApprovelCertCount(caCertInfoList,systemCategory);
                    if(approvelCertCount){
                        approvelCertCount.forEach((row,i)=>{
                            if(row.certCounts>=2){
                                //证书已存在{index}张证书正在审批中
                                msg += $t('page.common.detailNo',{index:(i+1)}) +  $t('komatsu.caCert.message.appvoeCertNumber',{index:row.certCounts-row.certCount}) + ' <br/>';
                            }
                        });
                    }
                }
                

                if(msg){
                    this.$Message.error('<br/>' + msg);
                    return false;
                }
                
                return true;
            },
            //获取审批中的用户证书数量
            async getApprovelCertCount(caCertInfoList,systemCategory){
                
                return new Promise((resolve, reject) => {
                    let url = '/ca/cacert/getCertCount';
                    let post = this.abHttpUtil.post(url, {
                        caCertInfoList:caCertInfoList,
                        systemCategory:systemCategory,
                        id:this.data.certApplyBus.id,
                        applySerial:this.data.certApplyBus.applySerial,
                    });

                    this.abTools.getResultData(post, (data,result) => {
                        resolve(data);
                    });

                });

            },
            //系统分类 选择触发
            systemCategoryChange(val){
                //单据编号-流水号 CA-申请系统名称-日期-001
                //this.$set(this.data.certApplyBus, 'applySerial', 'CA-'+val + '-' + this.curDate.replace(/\-/g,'') + '-' + this.serialNumber);

                this.$set(this.data.certApplyBus, 'systemCategoryName',this.systemCategoryList[val]);

                if(val!='KWING'){
                   let caCertInfoList = this.data.certApplyBus.caCertInfoList;
                    caCertInfoList.forEach(row=>{
                        row.receiptNumber = '';
                        row.kwingId = '';
                    });
                }

                if(val!='KOPEN'){
                   this.$set(this.data.certApplyBus, 'systemCategorySecondary','');
                }
                
                this.getCertCount();
            },
            //删除
            handleDelete(index) {
                if(this.supplierCompanyList.length>0 && this.applyType==1){
                    this.data.certApplyBus.caCertInfoList.splice(index, 1);
                }else if(this.data.certApplyBus.caCertInfoList.length>1){
                    this.data.certApplyBus.caCertInfoList.splice(index, 1);
                }
            },
            //获取供应商/公司下拉列表
            getSupplierCompany() {
                if(!this.isReadonly){
                    let url = '/ca/cacert/getSupplierCompany';
                    let post = this.abHttpUtil.post(url, {
                        
                    });

                    this.abTools.getResultData(post, (data,result) => {
                        if(data && data.length>0){
                            data.forEach(row=>{
                                this.supplierCompanyList.push(row);
                            });
                        }
                    });
                }
            },
            //供应商/公司 选择change 事件
            companyShortChange(val){

                let value = val.value;
                let name = val.label;
                this.data.certApplyBus.companyShortName = name;

                //选择用户过滤数据参数
                this.selectUserParams.leftTreeDialogParam.path_ = value;
                this.selectUserParams.group_id_ = value;
                this.selectUserParams.groupId = value;
                
            },
            //选择用户后 赋值
            pushOrgRelationList(dataArr) {
                console.log(dataArr);
                for (let i = 0; i < dataArr.length; i++) {
                    let row = dataArr[i];
                    
                    //是否列表数据已存在
                    let flag = false;
                    this.data.certApplyBus.caCertInfoList.forEach(item=>{
                        if(item.useUserId==row.id){
                            flag = true;
                        }
                    });

                    if(flag){
                        continue;
                    }

                    let caCertInfo = {
                        useUserId:row.id,
                        useUserAccount :row.account,
                        useUserName:row.fullname,
                        useUserEmail:row.email,
                        companyId:'',
                        companyShortName:'',
                        companyName:'',
                        receiptNumber:'',
                        startDate: this.curDate,
                        effective: this.defEffective,
                        createdBy: this.userInfo.id,
                        createdTime: this.curDate,
                        updateBy: this.userInfo.id,
                        updateTime: this.curDate,
                    };

                    //获取用户-供应商/公司
                    this.getCompany(row.id,'',data=>{

                        let companyEnShortName = data.enShortName?data.enShortName:'';
                        caCertInfo.companyId = data.id;
                        caCertInfo.companyShortName = companyEnShortName;
                        caCertInfo.companyName = data.name;

                         //证书编号
                        /* this.getSerialNo('certNumber',number=>{
                            caCertInfo.receiptNumber = companyEnShortName + number;
                        }); */
                    });
                   

                    this.data.certApplyBus.caCertInfoList.push(caCertInfo);
                }

                //获取用户证书数量
                this.getCertCount();
            },
        },
       
    };
</script>

<style lang="less" scoped>
    .col {
        .ivu-form-item {
            margin-left: -30px;

        }

        /deep/.ivu-input {
            height: 70px !important;
            text-align: left;
        }
    }

    .searchForm {
        margin-bottom: 5px;
        border: 1px solid #e5e5e5;

        .searchForm-div {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            position: relative;

            .searchForm-div-d {
                position: absolute;
                top: 50%;
                left: 0px;

                .searchForm-div-icon {
                    margin-right: 4px;
                }
            }

        }

    }

    .row {
        margin-bottom: 5px;
        margin-left: 0px !important;
        margin-right: 0px !important;

        .row-col {
            padding-left: 0px !important;
            padding-right: 0px !important;

            .from-ta {
                width: 100%;

                td:nth-child(1) {
                    background-color: #ebf7ff;
                    width: 20%;
                }

                td:nth-child(2) {
                    width: 30%;

                    .ivu-select {
                        width: 100%;
                        text-align: center;
                    }
                }

                td:nth-child(3) {
                    background-color: #ebf7ff;
                    width: 20%;
                }

                td:nth-child(4) {
                    width: 30%;
                }
            }
        }
    }

    .Row {
        margin: 10px;

        .from-ta {
            width: 100%;

            .label-td{
                 background-color: #ebf7ff
            }
            /* td:nth-child(2n) {
                background-color: #ebf7ff
            } */

            .ivu-input {
                //text-align: center;
            }

            .ivu-select-default {
                width: 100%;
                text-align: center;
            }

            .ivu-date-picker {
                width: 100%;
            }

            /* td:nth-child(1) {
                width: 2%;
            }

            td:nth-child(2),
            td:nth-child(8) {
                width: 7%;
            }

            td:nth-child(3),
            td:nth-child(5),
            td:nth-child(7),
            td:nth-child(9) {
                width: 12%;
            }

            td:nth-child(11) {
                width: 7%;
            }

            td:nth-child(13) {
                width: 4%;
            }
            td:nth-child(6){
                width: 7%;
            }

            td:nth-child(4),
            td:nth-child(8),
            td:nth-child(12) {
                width: 6%;
            } */
        }
    }

    .ivu-card-head {
        background: #2d8cf0;
        margin-top: 5px;

        ul {
            display: flex;
            align-items: center;

            span {
                margin-left: 5px;
                color: #fff;
            }

            li:nth-child(1) {
                margin-left: 10px !important;
                color: #fff;
            }

            li {
                margin-left: 20px;
                color: #fff;
            }
        }
    }

    .xrequired:after {
        content: '*';
        color: blue;
        font-size: 12px;
    }

    /deep/.ivu-btn-primary {
        background-color: #19BE6B !important;
        border-color: #19BE6B !important;
    }

    .ivu-upload {
        width: 100%;
    }

    /deep/ .input-center .ivu-input {
        text-align: center;
    }

    .from-ta td {
        padding: 1px;
    }

    /deep/.padding>.ivu-card-body {
        padding: 20px 10px 15px 10px !important;
    }

    .border {
        border: 1px solid rgb(219, 219, 219);
        border-radius: 10px 10px 0px 0px;
        height: 40px;
        display: flex;
        align-content: center;

        p {
            margin-left: 10px;
            margin-top: 10px;
        }
    }



    /* table-form css*/
    .form-table {
        border-collapse:collapse;
        text-align: center;
        width: 100%;
    }
    .form-table > thead > tr > th {
        position: relative;
        /* height: 100%; */
        padding: 8px 0;
    
    }


    .form-table > thead > tr > th,
    .form-table > tbody > tr > th,
    .form-table > tfoot > tr > th,
    .form-table > thead > tr > td,
    .form-table > tbody > tr > td,
    .form-table > tfoot > tr > td {
        /* border: 0px solid rgb(244 166 16 / 50%); */
        font-size: 12px;
        /* font-size: 1.2rem;*/
        /* vertical-align: top; */
        word-wrap: break-word;
        word-break: break-all;
        border: 1px solid #e8eaec;
    white-space: nowrap;
    }

    .form-table > thead > tr > td{
        background-color: #2d8cf0 ;
        color: #fff;
    }

    .form-table > thead > tr > th,
    .form-table > tbody > tr > th,
    .form-table > tfoot > tr > th {
        background-color: #2d8cf0 ;
        color: #fff;
        // font-size: 14px;
        /* background: rgb(244 166 16 / 50%); */
        /* background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #f0f0f0), color-stop(100%, #dedede));
        background: -webkit-linear-gradient(#f0f0f0 0%, #dedede 100%);
        background: -moz-linear-gradient(#f0f0f0 0%, #dedede 100%);
        background: -ms-linear-gradient(#f0f0f0 0%, #dedede 100%);
        background: linear-gradient(#f0f0f0 0%, #dedede 100%); */
    }
    .form-table > thead > tr > td,
    .form-table > tbody > tr > td,
    .form-table > tfoot > tr > td {
        background-color: #ffffff;
    }
    .form-table > thead > tr.even > td,
    .form-table > tbody > tr.even > td,
    .form-table > tfoot > tr.even > td {
        background-color: #f8f8f8;  
    }
    .form-table .red{
        color: red
    }

    .form-table > thead > tr > td{
        background-color: #2d8cf0 ;
        color: #fff;
    }

    /* table-form css*/
</style>